import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, FormikHelpers, FormikValues } from 'formik';
import { IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { VisibilityOff, Visibility } from '@mui/icons-material';
import Style from '../../utils/styles/Style';
import PAGE_ROUTES, { API_ROUTES } from '../../utils/constant';
import { toast } from 'react-toastify';
import axios from 'axios';

function ResetPassword() {
  const [isLoading, setIsLoading] = React.useState(false);
  const location = useLocation();
  const [token, setToken] = React.useState<string | null>(null);
  const validationSchema = Yup.object().shape({
    confirmpassword: Yup.string()
      .required('Confirm Password is required')
      .oneOf([Yup.ref('password')], 'Passwords must match'),
    password: Yup.string().required('Password is required'),
  });
  React.useEffect(() => {
    // Parse the query parameters from the URL
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get('token');
    setToken(tokenFromUrl);
  }, [location]);
  interface FormValues {
    confirmpassword: string;
    password: string;
  }

  const navigate = useNavigate();
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  const handleMouseDownConfirmPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <Box>
      <Container
        component="main"
        sx={Style.LoginForm?.SubContainer}
        maxWidth="xs"
      >
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Formik
            initialValues={{ confirmpassword: '', password: '' }}
            validationSchema={validationSchema}
            onSubmit={async (
              values: FormikValues,
              { resetForm }: FormikHelpers<FormValues>
            ) => {
              // Handle form submission
              setIsLoading(true);

              try {
                const resData = {
                  // confirmpassword: values.confirmpassword,
                  password: values.password,
                  token: token && token,
                };
                const response = await axios.post(
                  `${process.env.REACT_APP_BASE_URL}${API_ROUTES.resetMainPassword}`,
                  resData
                );

                navigate(PAGE_ROUTES.LOGIN);
                toast.success('Password Reset Successfully', {
                  position: 'bottom-right',
                });
                setIsLoading(false);
              } catch (error: any) {
                setIsLoading(false);
                console.error('Error in Loging', error.response.data.message);
                toast.error(error.response.data.message, {
                  position: 'bottom-right',
                });
              }
            }}
          >
            {({
              errors,
              touched,
              handleSubmit,
              handleBlur,
              handleChange,
              isSubmitting,
            }) => (
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="password"
                  label="Password"
                  type={showPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  id="password"
                  autoComplete="current-password"
                  error={touched.password && !!errors.password}
                  helperText={touched.password && errors.password}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="confirmpassword"
                  label="Confirm Password"
                  type={showConfirmPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowConfirmPassword}
                          onMouseDown={handleMouseDownConfirmPassword}
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  id="confirmpassword"
                  autoComplete="current-password"
                  error={touched.confirmpassword && !!errors.confirmpassword}
                  helperText={touched.confirmpassword && errors.confirmpassword}
                />

                <LoadingButton
                  loading={isLoading}
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2, textTransform: 'none' }}
                >
                  Chang Password
                </LoadingButton>
              </Box>
            )}
          </Formik>
        </Box>
      </Container>
    </Box>
  );
}

export default ResetPassword;
